import React from 'react';
import '../Css/Social.css'
import { FaLinkedinIn } from "@react-icons/all-files/fa/FaLinkedinIn";
import { FaGithub } from "@react-icons/all-files/fa/FaGithub";
import {FaInstagram } from "@react-icons/all-files/fa/FaInstagram";
import {FaFacebook} from "@react-icons/all-files/fa/FaFacebook";
import {FiMail} from "@react-icons/all-files/fi/FiMail";

const Social = () => {
    return (
        <>
        <div className='lg:ml-10'>
            <h1 className='social-title bg-slate-700 inline-block font-bold lg:text-2xl p-2 rounded-lg ml-12 lg:mt-16'>FOLLOW ME <span className='social-span'></span></h1>

           <div className='text-zinc-300  lg:text-3xl mt-6 lg:mt-5 ml-24 social-media'>
             <a href="https://www.linkedin.com/in/borhansahed/" target="blank"><FaLinkedinIn className='text-2xl lg:text-3xl'></FaLinkedinIn></a>
             <a href="https://github.com/borhansahed" target="blank"> <FaGithub className='text-2xl lg:text-3xl lg:mt-4'></FaGithub> </a>
            <a href="https://www.instagram.com/borhan_sahed/" target="blank"> <FaInstagram className='text-2xl lg:text-3xl lg:mt-4'></FaInstagram></a>
            <a href="https://www.facebook.com/mohammad.sah.sahed.3/" target="blank"> <FaFacebook className='text-2xl lg:text-3xl lg:mt-4'></FaFacebook></a>
          
            
           </div>

        </div>

        </>
    );
};

export default Social;